import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'
import {Button, Col, Empty, Input, Layout, message, Row, Select, Skeleton, Tabs, Dropdown, Upload,} from 'antd'
import css from './case-detail.module.less'
import * as constants from '@/constants/constants'
import GlobalCss from '@/global.module.less'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import rehypeRaw from 'rehype-raw'
import 'katex/dist/katex.min.css'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter' // 代码高亮
//高亮的主题，还有很多别的主题，可以自行选择
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism'
import CommonModal from '@/component/modal/CommonModal/CommonModal'
import { PlusOutlined, DownOutlined } from '@ant-design/icons'
import { FileList } from './FileList'
import CopyToClipboard from 'react-copy-to-clipboard'

import defaultCaseCover from '@/static/image/case/default_case_cover.png'
import gfm from 'remark-gfm'
import rehypeHighlight from 'rehype-highlight'

import type { MenuProps } from 'antd'
interface Props {}

const { Option } = Select
const { TextArea } = Input

export const CaseDetail: React.FC<Props> = (props: Props) => {
  const location = useLocation()
  const fromOAM = location.pathname?.includes('oam') ? 1 : 0
  const fromCourse = location?.pathname?.includes('course')
  const caseId = fromCourse
    ? location?.search?.split('case_id=')[1].split('&')[0]
    : location?.search?.split('case_id=')[1]
  const courseId = location?.search?.split('course_id=')[1]

  const history = useHistory()
  const [userLogin, setUserLogin] = useState(false) // 用户登录状态
  const [caseInfo, setCaseInfo] = useState<any>()

  const [caseLogo, setCaseLogo] = useState<any>() //保存实验的logo

  const [fileContent, setFileContent] = useState<any>()
  const [forkModalOpen, setForkModalOpen] = useState(false)
  const [editState, setEditState] = useState(false)
  const [coverFileList, setCoverfileList] = useState([])
  const [fields, setFields] = useState([]) //无全部的行业选择
  const [tabActiveKey, setTabActiveKey] = useState('exp_file')
  const [expDatasetInfo, setExpDatasetInfo] = useState<any>()

  const [activeMontedDatasetInfo, setActiveMontedDatasetInfo] = useState<any>(caseInfo?.mounted_datasets[0])
  const [infoLoading, setInfoLoading] = useState(true)
  const [ipynbFileLoading, setIpynbFileInfoLoading] = useState(true)
  const [reForkModalOpen, setReForkModalOpen] = useState(false)


  const add_link_target = ()=>{
    setTimeout(function(){
      const a_links = document.getElementsByTagName("a") //链接改为新弹出窗口效果
      for(let i=0; i < a_links.length;  i++){
          try{
            let href_ = a_links[i].getAttribute("href") as any
            if ( href_.indexOf('http') >= 0){
              a_links[i].setAttribute('target', '_blank');
            }
            
          }catch(error1){
            console.log(error1)
          }
        }
    }, 2000); //单位是毫秒

  }

  useEffect(() => {
    window.onload = function(){
      try{
        add_link_target()
      }catch(error){
        console.log(error)
      }
    } 

    queryCase()
    queryIpynbFile()
    queryDoMain()

    return () => {}
  }, [])

  const items: MenuProps['items'] = [
    {
      label: '重新Fork',
      key: '1',
      onClick: () => {
        setReForkModalOpen(true)
      },
    },
  ]

  const MenuItem = (props: any) => {
    const { dataset, onClick, index } = props

    return (
      <Row
        onClick={onClick}
        className={
          css.menuItem +
          ' ' +
          (dataset.dataset_id == activeMontedDatasetInfo?.dataset_id ||
          dataset.dataset_id == activeMontedDatasetInfo?.id
            ? css.activeMenuItem
            : '')
        }
        align={'top'}
        justify={'space-between'}
        wrap={false}
      >
        <Col>
          <Row
            align={'top'}
            justify={'start'}
            style={{ gap: '10px' }}
            wrap={false}
          >
            <Col>
              <span
                style={{
                  color: '#07C160',
                }}
                className="iconfont icon_a-zu3673"
              ></span>
            </Col>
            <Col>
              <div
                className={css.dtstTitle + ' ' + GlobalCss.oneLineTextOverflow}
                style={{ maxWidth: '220px' }}
                title={dataset.title}
              >
                {dataset.title}
              </div>
              <CopyToClipboard
                text={'../' + dataset?.base_path}
                onCopy={() => {
                  message.success('路径已复制')
                }}
              >
                <span
                  className={
                    css.datasetBasePath + ' ' + GlobalCss.oneLineTextOverflow
                  }
                >
                  {dataset?.base_path}
                </span>
              </CopyToClipboard>
            </Col>
          </Row>
        </Col>
        {/* <Col>
          <div
            className={GlobalCss.btnBox}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              unMountDataset(dataset, index)
            }}
          >
            <CloseOutlined className={css.deleteIcon} />
          </div>
        </Col> */}
      </Row>
    )
  }

  const getDatasetDetail = () => {
    let data = {
      dataset_id: caseInfo?.dataset_id,
    }

    let api_url = fromOAM == 1? 'dataset/api/oam_get_dataset_by_id/' : 'dataset/api/user_get_dataset_by_id/'

    sendHttpPostRequest(api_url, data, (res) => {
      if (res.code == 0) {
        setExpDatasetInfo(res.query_info)
      }
      if (res.code == -100) {
        message.error(res.message)
      }
    })
  }

  const onTabkeyChange = (key) => {
    setTabActiveKey(key)
    if (key == 'dataset') {
      getDatasetDetail()
    }
    if (key == 'mnt_dataset') {
      setActiveMontedDatasetInfo(caseInfo?.mounted_datasets[0])
    }
    
  }
  const queryDoMain = () => {
    message.destroy()
    const requestParams = {
      sessionid: Cookies.get('sessionid'),
    }
    sendHttpPostRequest(
      'case/api/query_domain_list',
      requestParams,
      queryDoMainCallback
    )
  }

  const queryDoMainCallback = (response: any) => {
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      // 成功
      const arrnew = response.domain_list
      setFields(arrnew)
    } else if (response.code == -501) {
      // 权限不足
      message.error('当前用户权限不足')
    } else {
      message.error(response.message)
    }
  }
  const caseReFork = () => {
    let data = {
      course_id: courseId,
      case_id: caseId,
    }
    // if (fromCourse) {
    //   data['course_id'] = courseId
    //   sendHttpPostRequest(
    //     'course/api/user_get_or_fork_course_case_by_id',
    //     data,
    //     (res) => {
    //       console.log(res)
    //       if (res.code == 0) {
    //         message.success('Fork成功')
    //         history.push(
    //           `/course-case-run?case_id=${res.case_id}?course_id=${courseId}`
    //         )
    //       }
    //     }
    //   )
    // } else {
    sendHttpPostRequest(
      'course/api/user_refork_course_case_by_id',
      data,
      (res) => {
        console.log(res)
        if (res.code == 0) {
          message.success('Fork成功')
          if (caseInfo?.is_system) {
            history.push(`/case-run?case_id=${res.case_info.case_id}`)
          } else {
            history.push(
              `/course-case-run?case_id=${res.case_info.case_id}?course_id=${courseId}`
            )
          }
        }
      }
    )
    // }
  }

  const routeToCaseRun = (case_id: number, course_id?: any) => {
    if (fromCourse && !caseInfo?.is_system) {
      window.open(`/course-case-run?case_id=${case_id}?course_id=${course_id}`)
    } else {
      history.push(`/case-run?case_id=${case_id}`)
    }
  }

  const caseFork = () => {
    let data = {
      case_id: caseId,
    }
    if (fromCourse) {
      data['course_id'] = courseId
      sendHttpPostRequest(
        'course/api/user_get_or_fork_course_case_by_id',
        data,
        (res) => {
          console.log(res)
          if (res.code == 0) {
            message.success('Fork成功')
            routeToCaseRun(res.case_info.case_id, courseId)
            // history.push(
            //   `/course-case-run?case_id=${res.case_id}?course_id=${courseId}`
            // )
          }
        }
      )
    } else {
      sendHttpPostRequest('case/api/user_fork_case', data, (res) => {
        console.log(res)
        if (res.code == 0) {
          message.success('Fork成功')
          routeToCaseRun(res.case_id)
          // history.push(`/case-run?case_id=${res.case_id}`)
        }
      })
    }
  }

  const queryIpynbFile = () => {
    setIpynbFileInfoLoading(true)
    let params = {
      case_id: caseId,
    }
    sendHttpPostRequest(
      'case/api/user_preview_case_ipynb_content',
      params,
      (res) => {
        if (res.code == 0) {
          setTimeout(() => {
            setIpynbFileInfoLoading(false)
          }, 1000)
          setFileContent(res.text_content)
        } else {
          message.error(res.message)
        }
      }
    )
  }

  /**
   * 查询实验信息
   */
  const queryCase = () => {
    setInfoLoading(true)
    let params = {
      sessionid: Cookies.get('sessionid'),
      case_id: caseId,
      is_my: '2',
      from_oam: fromOAM,
    }
    // if (caseId) {
    //   params['course_id'] = caseId
    // }

    if (fromCourse) {
      params['course_id'] = courseId
      sendHttpPostRequest(
        'course/api/user_query_course_case_by_id',
        params,
        queryCaseCallback
      )
    } else {
      sendHttpPostRequest(
        'case/api/query_case_by_id',
        params,
        queryCaseCallback
      )
    }
  }

  /**
   * 查询实验回调
   * @param response
   */
  const queryCaseCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      setUserLogin(false)
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      setUserLogin(true)
      setCaseInfo(response?.case_info)
      setCaseLogo(response?.case_info?.image)
      setInfoLoading(false)

      if (response.case_info.mounted_datasets.length > 0 ){
        queryMountedDatasetInfo(response.case_info.mounted_datasets[0].dataset_id)//默认展开第一个挂载数据集信息
      }

    } else {
      message.error(response.message)
    }
  }
  // 校验图片类型和大小
  function beforeCoverUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('请上传png或jpg格式的图片!')
    }
    const isLt5M = file.size / 1024 / 1024 < 5
    if (!isLt5M) {
      message.error('请上传小于5M的图片')
    }
    return isJpgOrPng && isLt5M
  }
  // 上传封面
  const onCoverChange = (info: any) => {
    setCoverfileList(info.fileList)
    const { status } = info.file
    if (status !== 'uploading') {
      //上传中
      console.log(info.file, info.fileList)
    }
    if (status === 'done') {
      //上传成功
      let new_cover = info.file.response.image_url
      let code = info.file.response.code
      if (code == -100) {
        sessionStorage.setItem("previousurl",window.location.href )
        document.getElementById('show-login-modal')!.click()
      } else {
        //caseInfo.image = new_cover
        setCaseLogo(new_cover)
        //setCaseInfo({ ...caseInfo })
      }
    } else if (status === 'error') {
      //上传失败
      message.error(`${info.file.name} file upload failed.`)
    }
  }
  const uploadCoverButton = (
    <div style={{ width: '200px', height: '150px' }}>
      {<PlusOutlined />} 上传封面
      <div
        style={{ marginTop: 6, color: '#666', fontSize: 12, padding: '0 10px' }}
      >
        （ 提示：请上传格式为jpg、png的图片，大小不得超过5M。）
      </div>
    </div>
  )

  // 上传cover传参
  const uploadCoverData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
    case_id: caseId,
    // token: window.location.search.split('&')[1].split('token=')[1],
  }

  const onCaseNameChange = (e) => {
    caseInfo.name = e.target.value
    setCaseInfo({ ...caseInfo })
  }

  // 即时保存实验领域
  const onCaseDomainChange = (domain: string) => {
    sendHttpPostRequest(
      'case/api/update_case',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        case_id: caseId,
        domain: domain,
      },
      saveCaseInfoCallback
    )
  }

  // 保存实验信息回调
  const saveCaseInfoCallback = (response: any) => {
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok) {
      //queryCase()
      setEditState(false)
    } else {
      message.error(response.message)
    }
  }

  const onSave = () => {
    if (!caseInfo?.name) {
      message.error('实验名称不能为空！')
      return
    }
    
    sendHttpPostRequest(
      'case/api/update_case',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        case_id: caseId,
        description: caseInfo.desc,
        name: caseInfo.name,
        cover: caseLogo //实验封面
      },
      saveCaseInfoCallback
    )
  }

  const onCaseDescChange = (e) => {
    caseInfo.desc = e.target.value
    setCaseInfo({ ...caseInfo })
  }

  const queryMountedDatasetInfo = (id) => {
    let data = {
      dataset_id: id,
    }
    sendHttpPostRequest('dataset/api/user_get_dataset_by_id/', data, (res) => {
      if (res.code == 0) {
        setActiveMontedDatasetInfo({
          ...res.query_info,
          dataset_id: res.query_info.id,
        })
      } else {
        message.error(res.message)
      }
    })
  }

  const onMenuClick = (dataset) => {
    queryMountedDatasetInfo(dataset?.dataset_id)

    
  }

  const CourseForkBtnGroup = (
    <div>
      {caseInfo?.need_fork ? (
        <Button
          style={{textShadow:'none', boxShadow:'none'}}
          onClick={() => setForkModalOpen(true)}
          className={GlobalCss.radiusBtn + ' ' + GlobalCss.defBtn}
        >
          Fork
        </Button>
      ) : (
        <Dropdown.Button
          overlayStyle={{
            width: '95px',
          }}
          type="primary"
          icon={<DownOutlined />}
          menu={{ items }}
          onClick={() => {
            let params = {
              case_id: caseId,
              course_id: courseId,
            }
            sendHttpPostRequest(
              'course/api/user_get_or_fork_course_case_by_id',
              params,
              (res) => {
                if (res.code == 0) {
                  // window.open(
                  //   `/course-case-run?case_id=${res.case_info.case_id}?course_id=${courseId}`
                  // )
                  window.open('/case-run?case_id=' + res.case_info.case_id)
                } else {
                  message.error(res.message)
                }
              }
            )
          }}
        >
          运行
        </Dropdown.Button>
      )}
    </div>
  )

  const DefaultForkBtnGroup = (
    <div className={css.btnGroup}>
      <Button
        style={{textShadow:'none', boxShadow:'none'}}
        className={GlobalCss.radiusBtn + ' ' + GlobalCss.defBtn}
        onClick={() => setEditState(true)}
      >
        编辑
      </Button>
      <Button
        className={GlobalCss.radiusBtn}
        style={{textShadow:'none', boxShadow:'none'}}
        type="primary"
        onClick={() => {
          if (fromCourse) {
            history.push(
              '/course-case-run?case_id=' + caseId + '?course_id=' + courseId
            )
          } else {
            window.open('/case-run?case_id=' + caseId)
          }
        }}
      >
        运行
      </Button>
    </div>
  )

  const renderBtnGroup = (
    <Col flex={'100px'} style={{ alignSelf: 'center' }}>
      {/* 是否是编辑状态 */}
      {editState ? (
            <div className={css.btnGroup}>
              <Button style={{textShadow:'none', boxShadow:'none'}} className={GlobalCss.radiusBtn} type="primary" onClick={onSave}>
                保存
              </Button>
            <Button
              className={GlobalCss.radiusBtn + ' ' + GlobalCss.defBtn}
              style={{textShadow:'none', boxShadow:'none'}}
              onClick={() => {
                setEditState(false)
              }}
            >
              取消
            </Button>
          </div>


      ) : caseInfo?.is_system ? (
        fromCourse && caseInfo?.is_course_teacher ? (
          CourseForkBtnGroup
        ) : fromCourse && caseInfo?.is_course_student ? (
          CourseForkBtnGroup
        ) : (
          <Button
          style={{textShadow:'none', boxShadow:'none'}}
            onClick={() => setForkModalOpen(true)}
            className={GlobalCss.radiusBtn + ' ' + GlobalCss.defBtn}
          >
            Fork
          </Button>
        )
      ) : fromCourse && caseInfo?.is_course_teacher ? (
        CourseForkBtnGroup
      ) : fromCourse && caseInfo?.is_course_student ? (
        CourseForkBtnGroup
      ) : (
        DefaultForkBtnGroup
      )}
    </Col>
  )
  return (
    <Layout style={{ minHeight: 750, backgroundColor: '#f9f9f9' }}>
      <div className={css.infoContain}>
        {infoLoading ? (
          <Skeleton active avatar paragraph={{ rows: 4 }} />
        ) : (
          <Row
            className={css.headerInfo}
            wrap={false}
            justify={'start'}
            align={'top'}
          >
            <Col
              flex={'250px'}
              className={GlobalCss.ColFlex + ' ' + css.uploadContain}
              style={{
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '150px',
              }}
            >
              {editState ? (
                <Upload
                  beforeUpload={beforeCoverUpload}
                  accept={'image/*'}
                  action={
                    constants.BACKEND_API_URL + 'case/api/upload_case_image'
                  }
                  listType="picture-card"
                  name="case_cover"
                  fileList={coverFileList}
                  onChange={onCoverChange}
                  data={uploadCoverData}
                  showUploadList={false}
                >
                  <img
                    width={250}
                    height={150}
                    style={{
                      minHeight: '150px',
                      minWidth: '250px',
                      borderRadius:5,
                    }}
                    src={
                      caseLogo
                        ? caseLogo.startsWith('http')
                          ? caseLogo
                          : constants.BACKEND_URL + caseLogo
                        : defaultCaseCover
                    }
                  />
                </Upload>
              ) : (
                <img
                  style={{borderRadius:5,}}
                  width={'250px'}
                  height={150}
                  src={
                    caseLogo
                      ? constants.BACKEND_URL + caseLogo
                      : defaultCaseCover
                  }
                  alt=""
                />
              )}
            </Col>
            <Col
              className={css.headerMid + ' ' + GlobalCss.ColFlex}
              flex={'auto'}
            >
              {editState ? (
                <Row
                  align={'middle'}
                  justify={'start'}
                  style={{ gap: '20px', width: '100%' }}
                  wrap={false}
                >
                  <Col flex={'auto'}>
                    <Input
                      maxLength={40}
                      onChange={onCaseNameChange}
                      value={caseInfo?.name}
                      placeholder="请输入实验名称"
                    />
                  </Col>
                  <Col flex={'200px'}>
                    <Select
                      defaultValue={caseInfo?.domain}
                      onChange={onCaseDomainChange}
                      style={{
                        textAlign: 'left',
                        display: 'block',
                        width: '200px',
                      }}
                    >
                      {fields?.map((item, index) => {
                        // 2、利用map属性
                        return (
                          <Option value={item} key={index}>
                            {item}
                          </Option>
                        )
                      })}
                    </Select>
                  </Col>
                </Row>
              ) : (
                <div className={css.headerTitle}>{caseInfo?.name}</div>
              )}
              {editState ? (
                ''
              ) : (
                <div style={{ marginBottom: 10 }}>
                  <span
                    style={{
                      padding: '3px 8px 3px 8px',
                      fontSize: 12,
                      height: 18,
                      color: '#07C160',
                      backgroundColor: '#EBEBEB',
                      borderRadius: 10,
                      marginBottom: 5,
                    }}
                  >
                    {caseInfo?.domain}
                  </span>
                {
                  (<span
                    style={{
                      color: '#666',
                      marginLeft: '10px',
                    }}
                  >
                    创建时间：{caseInfo?.create_time?.slice(0, 19)}
                  </span>)
                }
                </div>
              )}
              {editState ? (
                <TextArea
                  style={{ borderRadius: 3 }}
                  value={caseInfo?.desc}
                  defaultValue={caseInfo?.desc}
                  onChange={onCaseDescChange}
                  placeholder="请输入实验简介"
                  rows={4}
                />
              ) : (
                <div
                  title = {caseInfo?.desc}
                  className={GlobalCss.threeLinesTextOverflow + ' ' + css.desc}
                >
                  {caseInfo?.desc}
                </div>
              )}
            </Col>
            {renderBtnGroup}
          </Row>
        )}
        <div className={css.TabContain}>
          <Tabs activeKey={tabActiveKey} onChange={onTabkeyChange}>
            <Tabs.TabPane tab="实验文件" key="exp_file">
              {ipynbFileLoading ? (
                <div className={css.fileInfoContain}>
                  <Skeleton active paragraph={{ rows: 10 }} />
                </div>
              ) : (
                <div className={css.fileInfoContain}>
                  {fileContent?.cells?.map((cell) => {
                    return cell.cell_type == 'markdown' ? (
                      <div
                        key={cell.id}
                        id={cell.id}
                        className={css.markdownContain}
                      >
                        <ReactMarkdown
                          remarkPlugins={[gfm, remarkMath]}
                          rehypePlugins={[
                            rehypeHighlight,
                            rehypeKatex,
                            rehypeRaw,
                          ]}
                        >
                          {Array.isArray(cell.source) &&
                            cell.source?.join('\n')}
                        </ReactMarkdown>
                      </div>
                    ) : cell?.cell_type == 'code' ? (
                      <div className={css.codeContain}>
                        <SyntaxHighlighter
                          language={'python'}
                          key={cell.id}
                          style={oneLight}
                          id={cell.id}
                        >
                          {Array.isArray(cell.source)
                            ? cell.source?.join('')
                            : cell.source}
                        </SyntaxHighlighter>
                        {cell?.outputs?.length > 0
                          ? cell?.outputs?.map((output: any, i) => {
                              if (output.output_type == 'stream') {
                                return (
                                  <div
                                    key={
                                      output.output_type +
                                      output.execution_count
                                    }
                                    className={css.outputMarkdownContain}
                                  >
                                    <ReactMarkdown
                                      remarkPlugins={[
                                        [remarkGfm, { singleTilde: false }],
                                        [remarkMath],
                                      ]}
                                      rehypePlugins={[rehypeKatex, rehypeRaw]}
                                    >
                                      {output.text?.join('').trim().replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('\n', '<br/>')}
                                    </ReactMarkdown>
                                  </div>
                                )
                              } else if (output.output_type == 'display_data') {
                                return (
                                  <div     key={
                                    output.output_type +
                                    output.execution_count
                                  }>
                                  {output.data['image/png'] &&
                                     <div
                                
                                    style={{textAlign:'center'}}
                                    className={css.outputMarkdownContain}
                                  >
                                      <img
                                        style={{ objectFit: 'contain', maxWidth:'100%' }}
                                        src={
                                          'data:image/png;base64,' +
                                          output.data['image/png']
                                        }
                                        alt="图片"
                                      />
                                  </div>
                                  }
                                {output.data['image/svg+xml'] &&  
                                     <div
                           
                                    className={css.outputMarkdownContain}
                                  >
                                   <ReactMarkdown
                                      remarkPlugins={[
                                        [remarkGfm, { singleTilde: false }],
                                        [remarkMath],
                                      ]}
                                      rehypePlugins={[rehypeKatex, rehypeRaw]}
                                    >
                                      {output.data['image/svg+xml']
                                        ?.join('')}
                                    </ReactMarkdown> 
                                  </div>}

                                {output.data['text/plain'] &&  
                                     <div
                           
                                    className={css.outputMarkdownContain}
                                  >
                                   <ReactMarkdown
                                      remarkPlugins={[
                                        [remarkGfm, { singleTilde: false }],
                                        [remarkMath],
                                      ]}
                                      rehypePlugins={[rehypeKatex, rehypeRaw]}
                                    >
                                      {output.data['text/plain']
                                        ?.join('')
                                        ?.replaceAll('\n', '<br/>').replaceAll('<','&lt;').replaceAll('>','&gt;')}
                                    </ReactMarkdown> 
                                  </div>}


                                  {output.data['text/html'] && <ReactMarkdown
                                        remarkPlugins={[
                                          [remarkGfm, { singleTilde: false }],
                                          [remarkMath],
                                        ]}
                                        rehypePlugins={[rehypeKatex, rehypeRaw]}
                                      >
                                        {output.data['text/html'].join('')}
                                      </ReactMarkdown>
                                     }


                              </div> )
                              } else if (
                                output.output_type == 'execute_result'
                              ) {
                                return (
                                  <div
                                    key={
                                      output.output_type +
                                      output.execution_count
                                    }
                                    className={css.outputMarkdownContain}
                                  >
                                    {output.data['text/html']?.length > 0 ? (
                                      <ReactMarkdown
                                        remarkPlugins={[
                                          [remarkGfm, { singleTilde: false }],
                                          [remarkMath],
                                        ]}
                                        rehypePlugins={[rehypeKatex, rehypeRaw]}
                                      >
                                        {output.data['text/html']
                                          ?.join('')
                                          ?.replaceAll('<br/>', '')}
                                      </ReactMarkdown>
                                    ) : (
                                      <ReactMarkdown
                                        remarkPlugins={[
                                          [remarkGfm, { singleTilde: false }],
                                          [remarkMath],
                                        ]}
                                        rehypePlugins={[rehypeKatex, rehypeRaw]}
                                      >
                                        {output.data['text/plain']
                                          ?.join('')
                                          ?.replaceAll('\n', '<br/>')}
                                      </ReactMarkdown>
                                    )}
                                  </div>
                                )
                              }
                            })
                          : ''}
                      </div>
                    ) : null
                  })}
                </div>
              )}
            </Tabs.TabPane>
            <Tabs.TabPane tab="实验数据" key="dataset">
              <div
                style={{
                  padding: '0px 40px 30px 30px',
                  minHeight: '450px',
                }}
              >
                {expDatasetInfo && (
                  <FileList
                    actionPath={location.pathname + location.search}
                    datasetInfo={expDatasetInfo}
                    mode={caseInfo?.is_system || fromCourse ? 'monted' : 'case'}
                    requestType='user'
                    dataset_id = {expDatasetInfo?.id || expDatasetInfo?.dataset_id}
                  />
                )}
              </div>
            </Tabs.TabPane>
            {caseInfo?.mounted_datasets.length > 0 ? (
              <Tabs.TabPane tab="挂载数据" key="mnt_dataset">
                <div
                  style={{
                    padding: '0px 30px 30px 30px',
                    minHeight: '500px',
                  }}
                >
                  {caseInfo?.mounted_datasets?.length > 0 ? (
                    <Row className={css.montedContain} wrap={false}>
                      <Col className={css.montedMenu} flex={'280px'}>
                        {caseInfo?.mounted_datasets?.map((dtst, i) => {
                          return (
                            <MenuItem
                              key={dtst.dataset_id}
                              dataset={dtst}
                              onClick={onMenuClick.bind(this, dtst)}
                              index={i}
                            />
                          )
                        })}
                      </Col>
                      <Col className={css.montedTable} flex={'auto'}>
                        {activeMontedDatasetInfo && (
                          <div style={{ padding: '0px 10px 0px 12px'}}>
                            {' '}
                            <FileList
                              actionPath={location.pathname + location.search}
                              datasetInfo={activeMontedDatasetInfo}
                              mode={'monted'}
                              requestType='user'
                              dataset_id = {activeMontedDatasetInfo?.dataset_id}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '500px',
                        lineHeight: '500px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                          <span style={{ color: '#999999' }}>
                            暂无数据
                          </span>
                        }
                      />
                    </div>
                  )}
                </div>
              </Tabs.TabPane>
            ) : (
              ''
            )}
          </Tabs>
        </div>
      </div>
      <CommonModal
        modalTitle={'提示'}
        open={forkModalOpen}
        onOk={caseFork}
        onCancel={() => setForkModalOpen(false)}
        modalContent={
          <Row style={{ height: '100px' }} align={'middle'} justify={'center'}>
            <Col>
              确认要fork实验
              <span style={{margin:'0px 3px'}} className={GlobalCss.hlText}>{caseInfo?.name}</span>吗？
            </Col>
          </Row>
        }
      />
      <CommonModal
        modalTitle={'提示'}
        open={reForkModalOpen}
        onOk={caseReFork}
        onCancel={() => setReForkModalOpen(false)}
        modalContent={
          <Row style={{ height: '100px' }} align={'middle'} justify={'center'}>
            <Col>您已Fork过该实验，再次Fork会覆盖原有的实验，确认再次Fork?</Col>
          </Row>
        }
      />
    </Layout>
  )
}

export default CaseDetail
